import { HttpClient } from '@/shared/infra/http/HttpClient';
import type {
  H1bPetitionStatus,
  RecordH1bPetitionOutcome,
} from '../../application/domain/entities/H1bPetition';
import type { IH1bPetitionRepository } from '../../application/ports/outbound/IH1bPetitionRepository';

export class ApiH1bPetitionRepository implements IH1bPetitionRepository {
  constructor(private readonly httpClient: HttpClient) {}

  async fetchStatus(i9FormId: string): Promise<H1bPetitionStatus> {
    const response = await this.httpClient.get<H1bPetitionStatus>(
      `/reverification/${i9FormId}/h1b-petition`
    );
    return response.data;
  }

  async recordOutcome(
    i9FormId: string,
    outcome: RecordH1bPetitionOutcome
  ): Promise<H1bPetitionStatus> {
    const response = await this.httpClient.post<H1bPetitionStatus>(
      `/reverification/${i9FormId}/h1b-petition`,
      outcome
    );
    return response.data;
  }

  async uploadNotice(file: File): Promise<string> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    const response = await this.httpClient.post<{ url: string }>('/blob/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data.url;
  }
}
